export default "__VITE_ASSET__CZlkyHET__"